import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Example color
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const typographyDefine = {
  fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  h1: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
    [theme.breakpoints.up('xs')]: {
      fontSize: '36px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '64px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '74px',
    },
  },
  h2: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    fontWeight: '600',
    [theme.breakpoints.up('xs')]: {
      fontSize: '32px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '48px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '64px',
    },
  },
  h2Small: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    fontWeight: '600',
    fontSize: '20px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '36px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '48px',
    },
  },
  h3: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    fontWeight: '600',
    [theme.breakpoints.up('xs')]: {
      fontSize: '20px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '36px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '48px',
    },
  },
  h5: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    fontSize: '18px',
  },
  footerEmail: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    // fontSize: { xs: '40px', lg: '64px' },
    [theme.breakpoints.up('xs')]: {
      fontSize: '20px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '36px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '64px',
    },
  },
  body2: { fontFamily: '"Sora", "Helvetica", "Arial", sans-serif' },
  button: {
    fontFamily: 'Sora',
  },
};

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#D84C46', // Example primary color
    },
    secondary: {
      main: '#FFD02C', // Example secondary color
    },
    background: {
      default: '#ffffff', // Light mode background
      paper: '#f5f5f5', // Background for paper components
      colorSection: '#2a2e32',
    },
    text: {
      primary: '#ffffff', // Primary text color
      secondary: '#000000', // Secondary text color
      tertiary: '#666666',
      para: '#534F4F',
      classGray: '#616161',
    },
  },
  typography: typographyDefine,
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9', // Example primary color for dark mode
    },
    secondary: {
      main: '#FFD02C', // Example secondary color for dark mode
    },
    background: {
      default: '#121212', // Dark mode background
      paper: '#1d1d1d', // Background for paper components in dark mode
      colorSection: '#ffffff',
    },
    text: {
      primary: '#303030', // Primary text color in dark mode
      secondary: '#b0bec5', // Secondary text color in dark mode
      tertiary: '#666666',
    },
  },
  typography: typographyDefine,
});

export { lightTheme, darkTheme };

export default theme;
